// Variable to store the scroll handler function.
let collectionFilterStickinessScrollHandler = null; 

/**
 * Init collection filter stickiness.
 */
function initCollectionFilterStickiness() {

  // First remove the scroll event handler, if it is already set.
  if (collectionFilterStickinessScrollHandler !== null) {
    window.removeEventListener('scroll', collectionFilterStickinessScrollHandler);
  }

  // Get the collection filter's offset top and height.
  const collFilter = document.getElementById('collection-filter');
  const collFilterItem = document.querySelector('#collection-filter + .collection-filter__item');
  const collectionTitle = document.querySelector('.collection_hbc .section-header__title');
  const divAfterCollectionTitle = document.querySelector('.collection_hbc .section-header__title + div');
  let collFilterOffsetHeight = collFilter.offsetHeight;
  let collFilterOffsetTop = collFilter.offsetTop;
  let collectionTitleOffsetHeight = collectionTitle.offsetHeight;
  let collectionTitleOffsetTop = collectionTitle.offsetTop;

  // Enable / Disable Collection Filter Stickiness.
  function setCollectionFilterStickiness(sticky) {
    const stickySiteHeader = document.querySelector('#SiteHeader.site-header--stuck');

    if (sticky) {
      collFilter.classList.add("collection-filter--sticky");
      collFilter.style.top = stickySiteHeader.offsetHeight + collectionTitle.offsetHeight + 'px';
      collFilterItem.style.paddingTop = collFilterOffsetHeight + 'px';
    } else {
      collFilter.classList.remove("collection-filter--sticky");
      collFilter.style.top = '0px';
      collFilterItem.style.removeProperty('padding-top');
    }
  }

  // Enable / Disable Collection Title Stickiness.
  function setCollectionTitleStickiness(sticky) {
    const stickySiteHeader = document.querySelector('#SiteHeader.site-header--stuck');

    if (sticky) {
      collectionTitle.classList.add("section-header__title--sticky");
      collectionTitle.style.top = stickySiteHeader.offsetHeight + 'px';
      divAfterCollectionTitle.style.paddingTop = collectionTitleOffsetHeight + 'px';
    } else {
      collectionTitle.classList.remove("section-header__title--sticky");
      collectionTitle.style.top = '0px';
      divAfterCollectionTitle.style.removeProperty('padding-top');
    }
  }

  // Define new scroll handler.
  collectionFilterStickinessScrollHandler = function () {
    if (window.innerWidth < 768) {
      const stickySiteHeader = document.querySelector('#SiteHeader.site-header--stuck');

      if (stickySiteHeader !== null) {
        const stickyCollectionTitle =  collectionTitleOffsetTop - stickySiteHeader.offsetHeight;
        setCollectionTitleStickiness(window.scrollY > stickyCollectionTitle);

        const stickyCollFilter =  collFilterOffsetTop - (stickySiteHeader.offsetHeight + collectionTitle.offsetHeight);
        setCollectionFilterStickiness(window.scrollY > stickyCollFilter);
      } else {
        setCollectionFilterStickiness(false);
        setCollectionTitleStickiness(false);
      }
    }
  };

  // Add scroll hander to the scroll event.
  window.addEventListener('scroll', collectionFilterStickinessScrollHandler);
}

// When the CSS is also loaded.
window.addEventListener('load', function () {
  initCollectionFilterStickiness();
});